import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import { useTheme } from "@mui/material/styles";

const TwitterIcon = (props: { [x: string]: any }): JSX.Element => {
  const theme = useTheme() as any;
  return (
    <SvgIcon color="primary" {...props}>
      <g
        id="TwitterIcon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <path
          d="M8.96838735,20 C16.1380552,20 20.0612245,13.8425197 20.0612245,8.51181102 C20.0612245,8.33858268 20.0612245,8.16535433 20.0536214,7.99212598 C20.8139256,7.42519685 21.4753902,6.70866142 22,5.8976378 C21.3005202,6.22047244 20.5478191,6.43307087 19.7571028,6.53543307 C20.5630252,6.03937008 21.1788715,5.24409449 21.4753902,4.2992126 C20.7226891,4.76377953 19.8863545,5.09448819 18.9967987,5.27559055 C18.2821128,4.48818898 17.2709084,4 16.1532613,4 C14.0016006,4 12.2529012,5.81102362 12.2529012,8.03937008 C12.2529012,8.35433071 12.2909164,8.66141732 12.3517407,8.96062992 C9.11284514,8.79527559 6.23889556,7.18110236 4.31532613,4.74015748 C3.98079232,5.33858268 3.79071629,6.03149606 3.79071629,6.77165354 C3.79071629,8.17322835 4.48259304,9.40944882 5.52420968,10.1338583 C4.88555422,10.1102362 4.28491397,9.92913386 3.76030412,9.62992126 C3.76030412,9.64566929 3.76030412,9.66141732 3.76030412,9.68503937 C3.76030412,11.6377953 5.10604242,13.2755906 6.88515406,13.6456693 C6.55822329,13.7401575 6.21608643,13.7874016 5.8587435,13.7874016 C5.60784314,13.7874016 5.36454582,13.7637795 5.12885154,13.7165354 C5.62304922,15.3228346 7.06762705,16.488189 8.77070828,16.519685 C7.43257303,17.6062992 5.75230092,18.2519685 3.92757103,18.2519685 C3.61584634,18.2519685 3.30412165,18.2362205 3,18.1968504 C4.71828731,19.3307087 6.77110844,20 8.96838735,20"
          id="twitter"
          fill={theme.palette.iconColor}
        />
      </g>
    </SvgIcon>
  );
};

export default TwitterIcon;
